import { animationTransition } from '@shared/utils/animationTransition';
import { styled, Box, Flex, TextV2 } from '@withjoy/joykit';
import { StyleSystemProps } from '@withjoy/joykit/components/Box/Box.types';
import { pxToRem } from '@withjoy/joykit/theme';

//------------------------------------------------------
// Gift Basket Overlay Content

export const StyledGiftBasketContentRoot = styled(Flex)``;
export const StyledNavContainer = styled(Box)``;
export const StyledHeaderMsgContainer = styled(Box)``;
export const StyledProductListContainer = styled(Box)``;
export const StyledOverflowMsgContainer = styled(Box)``;
export const StyledZeroStateContainer = styled(Box)``;

const giftBasketContentRootStyles: StyleSystemProps = {
  paddingX: 6,
  paddingTop: 7,
  flexDirection: 'column',
  width: ['100%', null, null, pxToRem(418)],
  maxWidth: '100%',
  overflow: 'hidden',
  height: '100%',
  minHeight: ['100vh', null, null, pxToRem(812)],
  maxHeight: ['100vh', null, null, 'calc(75vh)'],
  _after: {
    content: '" "',
    display: 'block',
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    height: pxToRem(126),
    background: 'linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%)',
    zIndex: 'base',
    transform: 'rotate(-180deg)',
    borderTopLeftRadius: pxToRem(12),
    borderTopRightRadius: pxToRem(12),
  },
};

const giftBasketContentRootSkeletonStyles: StyleSystemProps = {
  display: 'flex',
  flexDirection: 'column',
  maxHeight: '100%',
};

const giftBasketContentDrawerRootSkeletonStyles: StyleSystemProps = {
  display: 'flex',
  flexDirection: 'column',
  maxHeight: '100%',
  overflow: 'hidden',
};

const giftBasketContentDrawerRootStyles: StyleSystemProps = {
  flexDirection: 'column',
  maxHeight: '100%',
  overflow: 'hidden',
};

const headerMsgContainerStyles: StyleSystemProps = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  paddingTop: 7,
};

const navContainerStyles: StyleSystemProps = {
  display: 'flex',
  justifyContent: 'center',
};
const productRowContainerStyles: StyleSystemProps = {
  display: 'flex',
  flexDirection: 'column',
  paddingBottom: pxToRem(96),
  paddingTop: 6,
  paddingLeft: 6,
  paddingRight: 6,
};
const overflowMsgContainerStyles: StyleSystemProps = {
  paddingTop: 6,
  paddingBottom: 3,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const zeroStateContainerStyles: StyleSystemProps = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  flex: 1,
};

const zeroStateMessageContainerStyles: StyleSystemProps = {
  paddingX: 5,
  paddingY: 4,
  marginTop: 6,
  textAlign: 'center',
};

//------------------------------------------------------
// ProductRow

export const StyledProductRowImageContainer = styled(Box)``;
export const StyledProductRowImage = styled(Box)``;
export const StyledProductRowBadge = styled(Box)``;

const productRowImageContainerStyles: StyleSystemProps = {
  position: 'relative',
  size: pxToRem(110),
  borderRadius: pxToRem(8),
  backgroundColor: 'mono2',
  flexShrink: 0,
};

const productRowImageStyles: StyleSystemProps = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'contain',
  borderRadius: 'inherit',
};

const productRowStatusBadgeStyles: StyleSystemProps = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'absolute',
  bottom: pxToRem(2),
  left: '50%',
  transform: 'translateX(-50%)',
  backgroundColor: 'white',
  borderRadius: pxToRem(7),
  width: 'calc(100% - 4px)',
  minHeight: pxToRem(26),
};

//------------------------------------------------------
// SegmentedController

export const StyledSegmentedControllerContainer = styled(Box)``;
export const StyledSegmentedControllerTab = styled(Box)``;

const segmentedControllerContainerStyles: StyleSystemProps = {
  backgroundColor: 'mono2',
  borderRadius: '9999px',
  padding: 2,
};

const segmentedControllerTabStyles: StyleSystemProps = {
  paddingX: 5,
  height: 8,
  borderRadius: '9999px',
  boxShadow: 'transparent',
  _selected: { backgroundColor: 'white', boxShadow: '0px 1px 3px -1px rgba(51, 51, 51, 0.1)' },
  transition: animationTransition('background-color', 'box-shadow'),
};

export const TextWithOverflow = styled(TextV2)<{ $maxNoLines: number }>`
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${props => props.$maxNoLines};
`;

//------------------------------------------------------
// Checklist

export const RegistryChecklistWrapper = styled(Box)``;
export const GiftListProgressWrapper = styled(Box)``;

const registryChecklistWrapperStyles: StyleSystemProps = {
  marginTop: 7,
  overflowY: 'scroll',
};

const giftListProgressWrapperStyles: StyleSystemProps = {
  margin: 4,
  padding: 4,
  border: '1px solid',
  borderColor: 'mono3',
  borderRadius: 12,
};

export const styles = {
  giftBasketContentRoot: giftBasketContentRootStyles,
  giftBasketContentDrawerRoot: giftBasketContentDrawerRootStyles,
  headerMsgContainer: headerMsgContainerStyles,
  navContainer: navContainerStyles,
  productRowContainer: productRowContainerStyles,
  overflowMsgContainer: overflowMsgContainerStyles,
  zeroStateContainer: zeroStateContainerStyles,
  zeroStateMessageContainer: zeroStateMessageContainerStyles,

  productRowImageContainer: productRowImageContainerStyles,
  productRowImage: productRowImageStyles,
  productRowStatusBadge: productRowStatusBadgeStyles,

  segmentedControllerContainer: segmentedControllerContainerStyles,
  segmentedControllerTab: segmentedControllerTabStyles,

  registryChecklistWrapper: registryChecklistWrapperStyles,
  giftListProgressWrapper: giftListProgressWrapperStyles,
  giftBasketContentRootSkeleton: giftBasketContentRootSkeletonStyles,
  giftBasketContentDrawerRootSkeleton: giftBasketContentDrawerRootSkeletonStyles,
};
